import { gql } from '@apollo/client';

export const LIST = gql`
  query ListAdmin($search: SearchAdminInput!) {
    listAdmin(searchAdmin: $search) {
      docs {
        _id
        email
        phone
        phonecode
        fullName
        status
        disable
        permissions
      }
      page
      limit
      totalDocs
      totalPages
    }
  }
`;
